<!-- =========================================================================================
    File Name: ProductListItem.vue
    Description: Item Component - List VIew
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-progress v-if="loading" indeterminate color="primary"></vs-progress>
    <div v-else class="vx-row mb-2 px-2 flex items-center justify-between">
      <div v-for="category in workingCategories" :key="category.id"
            class="sm:w-1/2 w-full py-1">
        <vs-checkbox v-model="category.isSelected" @input="updateAnalysisCategory(category)">
          {{ category.name }}
        </vs-checkbox>
        <!-- Companies -->

      </div>
    </div>

<!--    <div class="vx-row">-->
<!--      <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2"><vs-button class="mx-1 w-full">Save Changes</vs-button></div>-->
<!--      <div v-if="isModified" class="vx-col md:w-1/2 w-full mb-2"><vs-button class="mx-1 w-full" color="warning" type="border" @click="initializeWorkingCategories">Cancel</vs-button></div>-->
<!--    </div>-->
  </div>
</template>

<script>
  import types from '@/models';
  import helpers from '@/models/helpers';
  import api from '@/http/api';

  export default {
    data() {
      return {
        loading: false,
        helpers: helpers,
        productCategories: [],
        workingCategories: [],
      }
    },
    props: {
      product: {
        type: types.Product,
        required: true,
      },
      analysis: {
        type: types.CyclopediaAnalysis,
        required: true,
      },
      language: {
        type: types.Language,
        required: true,
      },
    },
    watch: {
      product: function (newVal, oldVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;
        this.productCategories = JSON.parse(JSON.stringify(newVal.cyclopedia_analysis_categories));
        this.initializeWorkingCategories();
      },
    },
    computed: {
    },
    methods: {
      async syncWithRemote() {
        this.loading = true;
        if (!this.product || this.product.product_id === 0) return;
        await Promise.all([
          this.fetchProductCategories(),
        ]);
        this.initializeWorkingCategories();
        this.loading = false;
      },
      async fetchProductCategories() {
        let product = await api.fetchLeanProduct(this.product.product_id, this.language);
        if (!product) return;
        this.productCategories = product.cyclopedia_analysis_categories;
        this.initializeWorkingCategories();
      },
      /**
       *
       * @param {types.CyclopediaAnalysisCategory} item
       * @returns {Promise<void>}
       */
      async updateAnalysisCategory(item) {
        // this.$vs.loading();

        // persist change
        let success = false;
        if (!item.isSelected) {
          success = await api.deleteProductFromAnalysisCategory(this.product.product_id, item);
        } else {
          success = await api.addProductToAnalysisCategory(this.product.product_id, item);
        }

        this.$vs.notify({
          title: success ? 'Success' : 'Error',
          text: success ? `${item.name} successfully updated` : `Error updating ${item.name}`,
          color: success ? 'success' : 'danger',
          icon: success ? 'check_circle_outline' : 'error'});


        if (!success) await this.syncWithRemote();

      },
      initializeWorkingCategories() {
        let temp = JSON.parse(JSON.stringify(this.analysis.categories));
        temp.forEach((category) => {
          category.isSelected = this.productCategories.filter((prodCategory) => prodCategory.id === category.id).length > 0;
        });
        this.workingCategories = temp;
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
